import { Component, OnInit, OnDestroy } from '@angular/core';
import { EventService } from '../../shared/services/event.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../shared/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-event-view',
  templateUrl: './event-view.component.html',
  styleUrls: ['./event-view.component.scss']
})
export class EventViewComponent implements OnInit, OnDestroy {
  fetching: { [key: string]: any } = {};
  data: any;
  usesvg = false;
  event_details: any[];
  lg = 'th';
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toastrService: ToastrService,
    public router: Router,
    private eventService: EventService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en');
    translateService.use('th');
  }

  ngOnInit() {
    this.fetching['getEvent'] = this.activatedRoute.params.subscribe(params => {
      // console.log(this.activatedRoute.snapshot.data['eventId']);
      // console.log(params['ticketId']);
      if (params['eventId']) {
        this.eventService
          .getOneById(params['eventId'])
          .then(res => {
            // console.log(res.data());
            if (res.data()) {
              this.data = res.data();
              const details = this.data.eventDetails.details;
              this.event_details = [];
              for (const i in details) {
                if (this.lg === details[i].lg) {
                  this.event_details.push(details[i]);
                }
              }
            }
            // console.log(this.event_details);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.eventService
          .getOneById(this.activatedRoute.snapshot.data['eventId'])
          .then(res => {
            // console.log(res.data());
            if (res.data()) {
              this.data = res.data();
              const details = this.data.eventDetails.details;
              this.event_details = [];
              for (const i in details) {
                if (this.lg === details[i].lg) {
                  this.event_details.push(details[i]);
                }
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    });
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  scroll(id) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  buy(type) {
    // console.log(this.authService.userAuthenticated);
    if (this.authService.userAuthenticated) {
      this.router.navigate([
        'user/booking',
        {
          eventId: this.data.id
        }
      ]);
    } else {
      this.router.navigate(['login']);
    }
  }
}
